// 主页
import { getPartyBuilding, getCarousel, getParksDynamic } from '@/api'

export default {
	namespaced: true,
	state: {
		partyBuildingList: [],
		carouselList: [],
		// 园区动态
		parksDynamicList: [],
	},
	mutations: {
		setPartyBuilding(state, payload) {
			state.partyBuildingList = payload.list
		},
		setCarousel(state, payload) {
			state.carouselList = payload.list
		},
		// 园区动态
		setParksDynamicList(state, payload) {
			state.parksDynamicList = payload
		},
	},
	actions: {
		fetchPartyBuilding(
			{ commit },
			{ page, limit } = { page: 1, limit: 10 }
		) {
			getPartyBuilding(page, limit).then((result) => {
				commit('setPartyBuilding', result)
			})
		},
		fetchCarousel({ commit }) {
			getCarousel().then((res) => {
				commit('setCarousel', res)
			})
		},
		fetchParksDynamic({ commit }) {
			getParksDynamic().then((list) => {
				commit('setParksDynamicList', list)
			})
		},
	},
}
